import { RootState } from "../../../RootReducer";

export const selectMapReady = (state: RootState) => state.mapPage.map.mapReady;
export const selectMapCenterCoordinates = (state: RootState) => state.mapPage.map.center;
export const selectMapBBox = (state: RootState) => state.mapPage.map.bbox;
// Selector to get the view-friendly (obstacle-free) portion of the map viewport bbox:
export const selectViewableMapBBox = (state: RootState) => state.mapPage.map.viewableBBox;
